const dashboardMainPages = [
    {
        id: "1",
        title: "add Product",
        url: "/addProduct"
    },
    {
        id: "2",
        title: "Main category",
        url: "/addCategory"
    },
    {
        id: "3",
        title: "add coupon",
        url: "/addCoupon"
    },
    {
        id: "4",
        title: "All Products",
        url: "/allProducts"
    },
    {
        id: "5",
        title: "Sub category",
        url: "/subCategory"
    },
    {
        id: "6",
        title: "edit coupons",
        url: "/editCoupons"
    },
    {
        id: "7",
        title: "orders",
        url: "/orders"
    },
    {
        id: "8",
        title: "Add brand",
        url: "/addBrand"
    },
    {
        id: "9",
        title: "Users",
        url: "/users"
    },
    {
        id: "10",
        title: "Contact Us",
        url: "/contact"
    },
    {
        id: "11",
        title: "Add Accessories",
        url: "/addaccessories"
    },
    {
        id: "12",
        title: "Add Accessories category",
        url: "/addaccessoriescategory"
    },
    {
        id: "13",
        title: "Add Models",
        url: "/addmodel"
    },
    {
        id: "14",
        title: "Rerder Category",
        url: "/Reordercategoryr"
    },
    {
        id: "15",
        title: "All Accessories",
        url: "/allAccessories"
    },
]

export default dashboardMainPages;